export const FRONTEND_VERSION = "1.0.0";
